export const normalizeText = (text: string) => {
	return text
		.replaceAll(/\+\d+/g, '')
		.replaceAll(/@recipient/g, '')
		.trim();
};
